import Marquee from "react-fast-marquee";
import { Reveal } from "../lib/reveal";
import { Award, Leaf, Scale, BarChart3, Building2, CalendarClock } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const badges = [
  { icon: Award, label: "ISO 14001:2015", sub: "Environmental management" },
  { icon: Leaf, label: "Swachh Bharat", sub: "Mission-aligned" },
  { icon: Scale, label: "NGT-compliant", sub: "Remediation approach" },
  { icon: BarChart3, label: "ESG-ready", sub: "Reporting support" },
  { icon: Building2, label: "15 Corporations", sub: "Municipal deployments" },
  { icon: CalendarClock, label: "Since 2019", sub: "On the ground" },
];

const partners = [
  "UltraTech Cement",
  "Dalmia Cement",
  "ACC Cement",
  "Reliance Bio-Energy",
  "Bhubaneswar Municipal Corporation",
  "Puri Municipality",
  "Hydro-safe Hosur",
  "Godda Nagar Parishad",
];

export const Recognition = () => {
  const { t } = useLang();
  return (
    <section id="recognition" data-testid="recognition-section" className="py-24 md:py-32 bg-bone">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Reveal className="flex items-center justify-center gap-3 mb-6">
            <span className="text-xs tracking-[0.22em] uppercase font-semibold text-moss">{t("Recognition & Standards", "मान्यता व मानक")}</span>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.05] text-ink">
              {t("Credentials government buyers can trust.", "साख जिन पर सरकारी क्रेता भरोसा कर सकें।")}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-stone/20 border border-stone/20 rounded-3xl overflow-hidden">
          {badges.map((b, i) => (
            <Reveal key={b.label} delay={i * 0.05}>
              <div className="bg-bone h-full px-5 py-8 flex flex-col items-center text-center gap-3">
                <b.icon size={26} strokeWidth={1.4} className="text-terracotta" />
                <div className="font-serif text-xl text-ink leading-none">{b.label}</div>
                <div className="text-[0.68rem] tracking-[0.1em] uppercase text-stone">{b.sub}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-14">
        <div className="text-center text-xs tracking-[0.18em] uppercase text-stone mb-6">{t("Trusted by public bodies & industry", "सार्वजनिक निकायों व उद्योग द्वारा विश्वसनीय")}</div>
        <div className="border-y border-stone/20 py-6 bg-sand">
          <Marquee speed={30} gradient={false} autoFill pauseOnHover>
            {partners.map((p, i) => (
              <span key={i} className="font-serif text-2xl md:text-3xl text-moss/80 px-10 md:px-16">{p}</span>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};
